import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input, Popconfirm, Button} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { useLocation, useNavigate } from 'react-router-dom';
import {DollarOutlined ,UserOutlined,BookOutlined,UsergroupAddOutlined,PlusCircleOutlined } from '@ant-design/icons';
import TollOutlinedIcon from '@mui/icons-material/TollOutlined';

import axios from '../apiClient';
import Alert from '../alert';
import moment from 'moment/moment';

const {RangePicker} = DatePicker;

export default function AcceptedBetsParlay() {
  const navigate = useNavigate();
  const location = useLocation();
  const [page,setPage] = useState(1);
  const [slips,setSlips] = useState([]);
  const [totalSlips, setTotalSlips] = useState();
  const [loading,setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [searchName,setSearchName] = useState('');
  const [slipId,setSlipId] = useState('');
  const [date,setDate] = useState({})
  const [slipsReport,setSlipsReport] = useState({})
  const didMount = useRef(false);


  async function fetchData() {
    // if(!searchName){
    //     setErrorMsg({ info: true, msg: "First input username" })
    //     setOpenAlert(true)
    //     return
    // }
    setLoading(true)
    let res = await axios.get(`/report/getSlipByMasterName?masterName=${searchName}&slipId=${slipId}&betStatus=accepted&oddType=mix_parlay&startDate=${date.startDate} 00:00:00&endDate=${date.endDate} 23:59:59&current=${page}&pageSize=10`)

    if (res.code != 200) {
        if(res.code == 404){
            setLoading(false)
            setSlips([])
            return
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setSlips(res.data.slip)
    setTotalSlips(res.data.pagination.total)
    setLoading(false)
  }


  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePageChange = (page) => setPage(page)
  
  const handleSearchUsername = ({currentTarget}) => setSearchName(currentTarget.value);

  const handleSearchSlipId = ({currentTarget}) => setSlipId(currentTarget.value.replace(/\s/g,''));
  
  const handleDateChange = async (v,dateString) => setDate({startDate: dateString[0],endDate: dateString[1]});

  const handleRejectAction = async (slipId) => {
    setLoading(true)
    let res = await axios.put(`/bet/updateSlipReject`,{slipId})
    setErrorMsg({ code: res.code, msg: res.message })
    setOpenAlert(true)
    setLoading(false)
    fetchData()
  }

  const handleRowClick = (rowData) =>{
    navigate('/bets/betDetails?action=parlay',{state: {rowData,date,searchName,slipId,includeRejectedUI: true}})
  }
  
  useEffect(()=> {
    getSlipsReport();
    if(!didMount.current){ // run when component before mount
      didMount.current = true;
      if(location?.state){
        const {date,searchName, slipId} = location.state;
        setSearchName(searchName);
        setSlipId(slipId);
        setDate(date);
      }else{
        const yesterday = moment().subtract(1,'days').format('YYYY-MM-DD');
        const tmr = moment().add(1,'days').format('YYYY-MM-DD');
        setDate({startDate: yesterday,endDate: tmr});
      }
    }else{
      fetchData();
    }
  },[searchName, slipId, date, page])

  async function getSlipsReport(){
    let res = await axios.get(`/report/getReportSlipByPending?betType=mix_parlay`);
     if(res.code == 200) {
      if(res.data){
        setSlipsReport(res.data)
      }
     }
  }

  const columns = [
      {
        title: 'Username',
        dataIndex: 'masterName',
        key: 'id',
      },
      
      {
        title: 'Slip Id',
        dataIndex: 'shortId',
        key: 'id',
      },
      {
        title: 'Bet Amount',
        dataIndex: 'betAmount',
        key: 'id',
      },
      {
        title: 'Bet Date',
        dataIndex: 'betDate',
        key: 'id',
        render: (date) => moment(date).format("DD-MM-YYYY h:mm A")
      },
      {
        title: 'Odd Type',
        key: 'id',
        dataIndex: 'betType',
      },
      {
        title: 'Bet Status',
        key: 'id',
        dataIndex: 'betStatus',
      },
      {
        title: 'Result Status',
        key: 'id',
        dataIndex: 'status',
      },
      {
        title: 'Action',
        fixed: 'right',
        render: (slip) => {
          const color = `#655DBB`
          return (
          <Space size="middle">
              <Button css={css`color: black;border-color: ${color};:hover{border-color: ${color};}`} color='success' variant="outlined" >
                    Detail
              </Button>
          </Space>
        )},
      },

  ];

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div style={{display: 'flex'}}>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <DollarOutlined   style={{fontSize: "2.5rem",marginRight: "1rem",color: "violet"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Bet Amount</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{Number(slipsReport?.total_bet_amount || 0).toLocaleString()}</h4>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <TollOutlinedIcon   style={{fontSize: "2.5rem",marginRight: "1rem",color: "orange"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Estimate Win Amount</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{Number(slipsReport?.estimate_win_amount || 0).toLocaleString()}</h4>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 2rem 2rem 1rem"}}>
            <BookOutlined   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#77ba4f"}}/>
             <div>
               <h4 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Slips</h4>
               <h4 style={{fontWeight: "normal",color: "black"}}>{Number(slipsReport?.total_slip || 0).toLocaleString()}</h4>
             </div>
          </div>


       </div>
       <div style={{display: 'flex'}}>
         <Space direction="vertical" size={12}>
          <RangePicker
            placement='topLeft'
            value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
            onChange={(v,dateString)=> handleDateChange(v,dateString)}/>
          </Space>
          <Input placeholder="Username..."  style={{width: "20%",marginLeft: "2rem"}} onChange={handleSearchUsername} value={searchName}/>
          <Input placeholder="Slip id..."  style={{width: "20%",marginLeft: "2rem"}} onChange={handleSearchSlipId} value={slipId}/>
       </div>
      <Table onRow={(rowData)=>{
          return(
            {onClick: () =>handleRowClick(rowData)}
          )
       }}
      loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={slips} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalSlips} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}


